/**
 * Get the CSRF token from the meta tag
 *
 * @returns {string} The CSRF token
 */
export const getCsrfToken = () => {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
};
